import { Grid, makeStyles, Tooltip, Typography } from "@material-ui/core";
import Axios from "axios";
import React, { useState } from "react";
import { FirebaseContext } from "../../Firebase";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

import QueueSelected from "./QueueSelected";
import Overview from "./Overview";
const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "30vw",
  },
  icon: {
    marginLeft: "15px",
  },
  datepickerRoot: {},
  root: {
    // backgroundColor: "#fff",
  },
  selectRoot: {
    backgroundColor: "#fff",
  },
  boxShadowOuter: {
    borderRadius: "5px",
    padding: "1vw",
    height: "8vh",
  },
  boxShadowOuterQueue: {
    borderRadius: "5px",
    padding: ".3vw",
    height: "6vh",
  },

  countContainer: {
    boxShadow:
      "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
    borderRadius: "5px",
    height: "12vh",
    padding: "1vw",
  },
}));
export default function Dashboard() {
  const classes = useStyles();

  const [facilities, setFacilities] = useState([]);
  const [choosedFacility, setChoosedFacility] = useState({});
  const [choosedFacilityIndex, setChoosedFacilityIndex] = useState(0);

  const [choosedQueueDetails, setChoosedQueueDetails] = useState({});

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  const [Called, setCalled] = useState(false);
  const [SelectedQueuIndex, setSelectedQueuIndex] = useState(-1);
  const [overview, setOverview] = useState([]);
  const [overviewCounts, setOverviewCounts] = useState({});

  const [msg, setMsg] = useState("");
  const [list, setList] = useState({});
  const [TotalInside, setTotalInside] = useState("");
  const [report, setReport] = useState([]);
  const [lastThirtyDaysData, setLastThirtyDaysData] = useState([]);

  const [queueFiveDaysSnapshotData, setQueueFiveDaysSnapshotData] = useState(
    []
  );

  const getUserFacilities = (fire) => {
    if (facilities.length === 0 && !Called) {
      setCalled(true);

      Axios.post(
        "/getUserFacilitiesApi",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("idToken"),
          },
        }
      ).then((res) => {
        // console.log("getUserFacilitiesApi", res.data);
        if (res.data.success) {
          // console.log("facilities response ", res.data.facilities);
          setFacilities(res.data.facilities);
          if (res.data.facilities.length > 0) {
            setChoosedFacilityIndex(0);
            setChoosedFacility(res.data.facilities[0]);
            // getOverview(res.data.facilities[0].facility._ref._path.segments[1]);
            getOverview(res.data.facilities[0].ref.split("facilities/")[1]);
            getLastThirtyDaysData(
              res.data.facilities[0].ref.split("facilities/")[1]
            );

            // handleFacilityChange(0)
          }
        } else {
          setFacilities([]);
          setMsg("No facilities found");
        }
      });
    }
  };

  const handleQueueSelect = (queueDetailsId, name, index) => {
    setSelectedQueuIndex(index);
    setChoosedQueueDetails({});
    setList({});
    setTotalInside("");
    setQueueFiveDaysSnapshotData([]);
    setReport([]);
    setMsg("");
    // console.log(
    //   "getListOfUsersApi is called where ququedetail id is ",
    //   queueDetailsId
    // );
    setChoosedQueueDetails({ id: queueDetailsId, name: name });
    // Axios.post(
    //   "https://asia-east2-apnaq-278811.cloudfunctions.net/getListOfUsersApi",
    //   { queueId: choosedQueueDetails.id, date: date }
    // ).then((response) => {
    //   if (response.data.success) {
        // console.log(response.data);
        // console.log("success");
    //     setList(response.data.queueData);
    //     setQueueFiveDaysSnapshotData(response.data.queueFiveDaysSnapshotData);
    //   } else {
    //     setMsg("No queue present on this date for this queue");
        // console.log("failed");
    //   }
    // });
  };
  // const handleDateChange = (e) => {
    // console.log(e.target.value);
    // console.log(date);
  //   setDate(e.target.value);
  // };

  // const handleGenerateReport = () => {
    // console.log("handleGenerateReport called");
  //   if (Object.keys(list).length > 0 && list._path.segments[1]) {
      // console.log("queuId", list._path.segments[1]);
  //     Axios.post(
  //       "https://asia-east2-apnaq-278811.cloudfunctions.net/generateReportApi",
  //       { queueId: list._path.segments[1] },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           authorization: localStorage.getItem("idToken"),
  //         },
  //       }
  //     )
  //       .then((res) => {
          // console.log("handleSelectQueue response", res.data);
  //         setReport(res.data.Report);
  //         // if(res.data.Report.length>0){
  //         //   return( <CSVDownload data={res.data.Report} target="_blank" />)
  //         // }
  //       })
  //       .catch((err) => {
          // console.log(err);
  //       });
  //   }
  // };

  // const getLables = () => {
  //   if (queueFiveDaysSnapshotData.length > 0) {
  //     const labels = queueFiveDaysSnapshotData.map((day) => day.date);
  //     return labels;
  //   }
  // };
  // const getRegistered = () => {
  //   if (queueFiveDaysSnapshotData.length > 0) {
  //     const filteredWithUid = queueFiveDaysSnapshotData.map((day) =>
  //       day.line.filter((lin) => lin.uid !== null)
  //     );
  //     return filteredWithUid.map((filter) => filter.length);
  //   }
  // };
  // const getEntryScan = () => {
  //   if (queueFiveDaysSnapshotData.length > 0) {
  //     const filteredWithEntry = queueFiveDaysSnapshotData.map((day) =>
  //       day.line.filter((lin) => lin.isExited === true)
  //     );
  //     return filteredWithEntry.map((filter) => filter.length);
  //   }
  // };
  // const getExitScan = () => {
  //   if (queueFiveDaysSnapshotData.length > 0) {
  //     const filteredWithExit = queueFiveDaysSnapshotData.map((day) =>
  //       day.line.filter((lin) => lin.isEntryScan === true)
  //     );
  //     return filteredWithExit.map((filter) => filter.length);
  //   }
  // };
  const getLastThirtyDaysData = (facilityId) => {
    Axios.post("https://asia-east2-apnaq-prod.cloudfunctions.net/getLastThirtyDaysChartDataApi", {
      facilityId: facilityId,
    }).then((res) => {
      // console.log("getLastThirtyDaysData response : ", res.data);
      if (res.data.success) {
        console.log(res.data);
        setLastThirtyDaysData(res.data.finalData);
      }
    });
  };
  const getOverview = (facilityId) => {
    // console.log(
    //   "getOverview called for facility id ",
    //   facilityId,
    //   "and date ",
    //   date
    // );
    Axios.post(
      "https://asia-east2-apnaq-prod.cloudfunctions.net/getOverviewApi",
      { facilityId: facilityId, date: date }
      // {
      //   headers: {
      //     "Content-Type": "application/json",
      //     authorization: localStorage.getItem("idToken"),
      //   },
      // }
    ).then((res) => {
      // console.log("overview response : ", res.data);

      if (res.data.success) {
        setOverview(res.data.data);
        var insideFacility = 0;
        var count = 0;
        var entryCount = 0;
        var peopleCount = 0;
        var totalSlots = 0;
        var totalVisitorsAllowedInside = 0;
        if (res.data.data.length > 0) {
          // console.log("length > 0");
          res.data.data.forEach((data, index) => {
            insideFacility = insideFacility + parseInt(data[0].totalInside);
            entryCount = entryCount + parseInt(data[0].entryCount);
            peopleCount = peopleCount + parseInt(data[0].peopleCount);
            count = count + parseInt(data[0].count);
            totalSlots = totalSlots + parseInt(data[0].totalSlots);
            totalVisitorsAllowedInside = parseInt(
              data[0].totalVisitorsAllowedInside
            );
            if (index === res.data.data.length - 1) {
              // console.log("equal");
              setOverviewCounts({
                insideFacility,
                count,
                entryCount,
                peopleCount,
                totalSlots,
                totalVisitorsAllowedInside,
              });
            }
          });
        } else {
          setOverviewCounts({
            insideFacility: 0,
            count: 0,
            entryCount: 0,
            peopleCount: 0,
            totalSlots: 0,
            totalVisitorsAllowedInside: 0,
          });
        }
      } else {
        setMsg("no such facility");
      }
    });
  };
  const handleFacilityChange = (index) => {
    if (choosedFacilityIndex !== index) {
      setChoosedFacility(facilities[index]);
      // getOverview(facilities[index].facility._ref._path.segments[1]);
      getOverview(facilities[index].ref.split("facilities/")[1]);
      getLastThirtyDaysData(facilities[index].ref.split("facilities/")[1]);
      setLastThirtyDaysData([]);
      setOverview([]);
      setOverviewCounts({});
      setChoosedFacilityIndex(index);
      setSelectedQueuIndex(-1);
      setChoosedQueueDetails({});
      setList({});
      setTotalInside("");
      setReport([]);
      setMsg("");
    } else {
    }
  };

  return (
    <Grid container className={classes.root}>
      <FirebaseContext.Consumer>
        {(fire) => (
          <>
            {getUserFacilities(fire)}

            <Grid container lg={12}>
              <Grid container spacing={3}>
                {facilities.length > 0
                  ? facilities.map((facility, index) => (
                      <>
                        <Grid lg={2} item>
                          <Grid
                            container
                            alignItems="center"
                            className={classes.boxShadowOuter}
                            style={{
                              boxShadow:
                                choosedFacilityIndex === index
                                  ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                                  : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
                            }}
                            onClick={() => {
                              handleFacilityChange(index);
                            }}
                          >
                            <Grid container justify="center">
                              <Typography
                                style={{
                                  color:
                                    choosedFacilityIndex === index
                                      ? "#22FCA8"
                                      : "#ffffff",
                                  fontFamily: "'Poppins', sansSerif",
                                  fontWeight: "500",
                                  fontSize: "10px",
                                }}
                              >
                                { facility.name.charAt(0).toUpperCase() + facility.name.slice(1)}
                                {facility.active ? (
                                  <CheckCircleOutlineIcon
                                    style={{
                                      fontSize: "15px",
                                      color: "#22FCA8",
                                      marginLeft:"10px",
                                      position:"relative",
                                      top:"5px"
                                    }}
                                  />
                                ) : (
                                  <CancelOutlinedIcon
                                    style={{
                                      fontSize: "15px",
                                      marginLeft:"10px",
                                      position:"relative",
                                      top:"5px",
                                      color: "#FF4183",
                                    }}
                                  />
                                )}
                              </Typography>
                              
                                
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    ))
                  : null}
              </Grid>
            </Grid>
            <Grid
              container
              lg={12}
              style={{ marginTop: "1.5vw", marginBottom: "1.5vw" }}
            >
              {Object.keys(choosedFacility).length > 0 ? (
                choosedFacility.queueDetails ? (
                  <Grid container spacing={3}>
                    <Grid item lg={2}>
                      <Grid
                        container
                        justify="center"
                        onClick={() => setSelectedQueuIndex(-1)}
                        className={classes.boxShadowOuterQueue}
                        style={{
                          boxShadow:
                            SelectedQueuIndex === -1
                              ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                              : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
                        }}
                        alignItems="center"
                      >
                        <Typography
                          style={{
                            fontSize: "16px",
                            fontFamily: "'Poppins', sansSerif",
                            color:
                              SelectedQueuIndex === -1 ? "#22FCA8" : "#5A9BB7",
                            fontWeight:
                              SelectedQueuIndex === -1 ? "300" : "200",
                          }}
                        >
                          Overview
                        </Typography>
                      </Grid>
                    </Grid>
                    {choosedFacility.queueDetails.map((queue, index) =>
                      queue.name ? (
                        <Tooltip title={queue.name} arrow>
                          <Grid
                            item
                            lg={2}
                            onClick={() =>
                              handleQueueSelect(
                                queue.ref._path.segments[1],
                                queue.name,
                                index
                              )
                            }
                          >
                            {" "}
                            <Grid
                              container
                              justify="center"
                              className={classes.boxShadowOuterQueue}
                              style={{
                                boxShadow:
                                  SelectedQueuIndex === index
                                    ? "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)"
                                    : "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
                              }}
                              alignItems="center"
                            >
                              <Typography
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "'Poppins', sansSerif",
                                  color:
                                    SelectedQueuIndex === index
                                      ? "#22FCA8"
                                      : "#5A9BB7",
                                  fontWeight:
                                    SelectedQueuIndex === index ? "300" : "200",
                                }}
                              >
                                { queue.name.charAt(0).toUpperCase() + queue.name.slice(1,21)}
                                <Grid container justify="center">
                                  <Typography
                                    style={{
                                      fontFamily: "'Poppins', sansSerif",
                                      fontWeight: "500",
                                      fontSize: "10px",
                                      color:
                                        queue.status === "open"
                                          ? "#2AFCA8"
                                          : queue.status === "closed"
                                          ? "#FF4183"
                                          : queue.status === "not open"
                                          ? "#7883AA"
                                          : queue.status === "delayed"
                                          ? "#FF9690"
                                          : "yellow",
                                    }}
                                  >
                                    {queue.status.toUpperCase()}
                                  </Typography>
                                </Grid>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Tooltip>
                      ) : null
                    )}
                  </Grid>
                ) : null
              ) : null}
            </Grid>
            {SelectedQueuIndex !== -1 ? (
              <QueueSelected choosedQueueDetails={choosedQueueDetails} />
            ) : (
              <Overview
                overview={overview}
                insideFacility={overviewCounts.insideFacility}
                count={overviewCounts.count}
                entryCount={overviewCounts.entryCount}
                peopleCount={overviewCounts.peopleCount}
                totalSlots={overviewCounts.totalSlots}
                lastThirtyDaysData={lastThirtyDaysData}
                totalVisitorsAllowedInside={
                  overviewCounts.totalVisitorsAllowedInside
                }
                // overviewCounts={overviewCounts}
              />
            )}
          </>
        )}
      </FirebaseContext.Consumer>
    </Grid>
  );
}
